import axios from 'axios';

class ActivityLoggerService {
    constructor() {
        this.client = axios.create({
            baseURL: '/FRHandlers'
        });
    }
    logConfiguratorActivity(a) {
        console.log('Do log configurator activity...', a);
        this.client.post('/EmsActivityLogger.ashx', a).then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}

export let activityLoggerService = new ActivityLoggerService();



// WEBPACK FOOTER //
// ./CMS/scripts/modules/ActivityLoggerService.js